import { differenceInCalendarDays } from 'date-fns';

interface GetScheduleDayParams {
  startDate: Date;
  isRegularWeek: boolean;
}

export default function getScheduleDay({
  startDate,
  isRegularWeek,
}: GetScheduleDayParams) {
  if (isRegularWeek) {
    const dayValue = startDate.getDay();
    return dayValue === 0 ? 7 : dayValue;
  }

  const currentDate = new Date();
  const dayDifference = differenceInCalendarDays(startDate, currentDate);
  return dayDifference + 1;
}
